import React from 'react';
import Lottie from 'lottie-react';
import rotatingAnimation from '../assets/rotating.json';

const RotatingCircleImages = () => {
    return (
        <div
            className={`
        relative 
        mx-auto 
        overflow-visible 
        w-[90%] 
        max-w-[1300px]

        /* Mobile: bigger scale, move up */
        scale-110

        /* Desktop: normal scale, no negative margin */
        sm:scale-90
      `}
        >
            <Lottie
                animationData={rotatingAnimation}
                loop
                style={{
                    width: '100%',
                    height: 'auto',
                }}
            />
        </div>
    );
};

export default RotatingCircleImages;
